import chroma from "chroma-js";

/**
 * use this function to get environment variables.
 * leave out the REACT_APP_ prefix.
 * throws an error if requested env variable is missing
 */
export function env(name: string) {
  const fullName = `REACT_APP_${name}`;
  const value = process.env[fullName] ?? "";
  if (value === "") throw Error(`${name} environment variable missing`);
  return value;
}

export const getTimelineMetrics = () => {
  const width = window.innerWidth;
  let eventWidth;
  let eventGap;

  if (width < 1750) {
    eventWidth = 700;
    eventGap = 100;
    console.log(width);
  } else {
    eventWidth = 900;
    eventGap = 200;
  }
  return { eventWidth, eventGap };
};
/**
 * given an array of colors, a value, a start and an end,
 * calculate the percentage the value is between the start and the end
 * and then find the color at that position in the gradient.
 * colors can be hex or color names (eg "red")
 */
export function colorScale(
  colors: string[],
  value: number,
  scale: { start: number; end: number }
) {
  const percentage = (value - scale.start) / (scale.end - scale.start);
  const gradient = chroma.scale(colors);
  return gradient(percentage).hex();
}

/**
 *
 * @param lastUpdated converts lastUpdated to a timestamp for lastUpdated button
 * @returns
 */
export function formatTime(lastUpdated: string) {
  return new Date(lastUpdated).toLocaleString();
}
